import { useEffect, useState } from "react";
import { openNotificationWithIcon } from "../../utils/helper";
import { getRankings } from "../../api/ranking/ranking";

const useRankings = () => {
  const [rankings, setRankings] = useState<any>([]);
  const [loadingRankings, setLoadingRankings] = useState(false);

  const fetchRankings = async () => {
    try {
      setLoadingRankings(true);
      const res = await getRankings();
      const { data } = res.data;
      const sortedData = data.sort(
        (a: any, b: any) => a.basePointsRequired - b.basePointsRequired
      );
      setRankings(sortedData);
      setLoadingRankings(false);
    } catch (error: any) {
      setLoadingRankings(false);
      if (error?.response) {
        openNotificationWithIcon(
          "error",
          "Get Rankings",
          `${error?.response?.data?.message || "Something went wrong"}`
        );
      } else {
        openNotificationWithIcon(
          "error",
          "Get Rankings",
          "Something went wrong"
        );
      }
    }
  };

  useEffect(() => {
    fetchRankings();

    // eslint-disable-next-line
  }, []);

  return { rankings, loadingRankings };
};

export default useRankings;
